import React, { useEffect } from 'react'
import { TextField as TF } from '@material-ui/core'
import { Control, Controller } from 'react-hook-form'
import { FieldError } from './FieldError'
import { AsYouType } from 'libphonenumber-js'
import './FormFields.css'

interface PhoneFieldProps {
  control: Control
  name: string
  label?: string
  error?: any
  setField?: any 
  fields?: any
}

export const PhoneField: React.FC<PhoneFieldProps> = ({ control, label = 'Phone Number', name, error, setField, fields }) => {
  const phoneField = fields?.phone

  const inpProps = phoneField ? { maxLength: phoneField[0] === '1' ? 16 : 14 } : { maxLength: 14 }

  useEffect(() => {
    if (phoneField) {
      const formattedPhone = new AsYouType('US').input(phoneField)
      setField('phone', formattedPhone)
    }
  }, [phoneField, setField])

  return (
    <>
      <Controller
        control={control}
        name={name}
        label={label}
        render={(props) => <TF {...props} className='inputField' type="tel" label={label} inputProps={{ ...inpProps, "aria-label": label }} />}
      />
      <FieldError fieldError={error} /> 
    </>
  )
}
